import { booleanAttribute, Component, input } from '@angular/core';

export const cardVariants = ['elevated', 'filled', 'outlined'] as const;
export type CardVariant = typeof cardVariants[number];

export const bspkCardDefaults = {
  hidePadding: false,
  variant: 'elevated',
} as const;

@Component({
  selector: 'bspk-card',
  imports: [],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  host: {
    '[attr.data-card]': 'true',
    '[attr.data-variant]': 'variant()',
    '[attr.data-hide-padding]': 'hidePadding() ? true : null',
  },
})
export class BspkCard {
  hidePadding = input(bspkCardDefaults.hidePadding, { transform: booleanAttribute });
  variant = input<CardVariant>(bspkCardDefaults.variant);
}
